export default __webpack_public_path__ + "static/media/1107.d3fd41e2.png";